"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
let TrialsBarchart = class TrialsBarchart extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.barMaxWidth = 100;
        this.barMaxPerc = 50;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    myWidth() {
        const theValue = this.cureValue();
        let currentBarWidth = this.barMaxWidth * (this.barMaxPerc / 100);
        let currentPercentage = Math.abs(theValue.num / 100);
        let perc = currentPercentage * currentBarWidth;
        return perc + 'px';
    }
    myPosition() {
        const theValue = this.cureValue();
        let styleStr = '';
        let currentBarWidth = this.barMaxWidth * (this.barMaxPerc / 100);
        let currentPercentage = Math.abs(theValue.num / 100);
        let perc = currentPercentage * currentBarWidth;
        if (this.value >= 0) {
            styleStr = 'left: ' + (perc + 7).toString() + 'px; right: initial;';
        }
        if (this.value < 0) {
            styleStr = 'right: ' + (perc + 7).toString() + 'px; left: initial;';
        }
        return styleStr;
    }
    get isTrialsSummary() {
        return this.type !== 'study';
    }
    /*     const gheom2Perc = (x: number) => {
        if (!x) return '-';
        let beautifyNumber;
    
        if (x > 200) {
            if (x > 1000) {
                beautifyNumber = (Math.round(x) / 100).toFixed(0) + 'x';
            } else {
                beautifyNumber = (Math.round(x) / 100).toFixed(1) + 'x';
            }
        } else {
            beautifyNumber = (+x).toFixed(2) + '%';
        }
        return beautifyNumber;
    }; */
    cureValue() {
        let curatedValue = {
            num: 0,
            str: ''
        };
        if (this.value >= 0) {
            if (this.value > 100) {
                curatedValue.num = 100;
                if (this.value > 200) {
                    if (this.value > 1000) {
                        if (this.value > 50000) {
                            curatedValue.str = '> 500x';
                        }
                        else {
                            curatedValue.str = (Math.round(this.value) / 100).toFixed(1).toString() + 'x';
                        }
                    }
                    else {
                        curatedValue.str = (Math.round(this.value) / 100).toFixed(2) + 'x';
                    }
                }
                else {
                    curatedValue.str = (Math.round(this.value) / 100).toFixed(2) + 'x';
                }
            }
            else {
                curatedValue.num = this.value;
                curatedValue.str = curatedValue.num.toFixed(1).toString() + '%';
            }
        }
        else {
            if (this.value < -100) {
                curatedValue.num = -100;
                curatedValue.str = '-100%';
                if (this.value < -200) {
                    if (this.value < -1000) {
                        if (this.value < -50000) {
                            curatedValue.str = '< -500x';
                        }
                        else {
                            curatedValue.str = (Math.round(this.value) / 100).toFixed(1).toString() + 'x';
                        }
                    }
                    else {
                        curatedValue.str = (Math.round(this.value) / 100).toFixed(2) + 'x';
                    }
                }
                else {
                    curatedValue.str = (Math.round(this.value) / 100).toFixed(2).toString() + '%';
                }
            }
            else {
                curatedValue.num = this.value;
                curatedValue.str = curatedValue.num.toFixed(1).toString() + '%';
            }
        }
        return curatedValue;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TrialsBarchart.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'study' })
], TrialsBarchart.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TrialsBarchart.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '-' })
], TrialsBarchart.prototype, "claimType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], TrialsBarchart.prototype, "isRelevant", void 0);
TrialsBarchart = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {},
    })
], TrialsBarchart);
exports.default = TrialsBarchart;
